import slotPositionsConfig from './slot-positions-config.json';
var TOO_BIG_POSITION = 1000000000;
export default function slotTypePositionCalculator(sportId, matchPhase, slot) {
    var slotType = slot.type;
    var sportSlotPositions = slotPositionsConfig[sportId];
    if (!sportSlotPositions) {
        return TOO_BIG_POSITION;
    }
    var matchPhaseSlotPositions = sportSlotPositions[matchPhase];
    if (!matchPhaseSlotPositions) {
        return TOO_BIG_POSITION;
    }
    return matchPhaseSlotPositions[slotType] * 10000 || TOO_BIG_POSITION;
}



// WEBPACK FOOTER //
// ./src/components/grid/slot-arrangement-policies/positionCalculators/SlotTypePositionCalculator.js